// src/util/GoogleMapsProvider.js
import { createContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

// Create the context
export const GoogleMapsContext = createContext();

const GOOGLE_MAPS_LIBRARIES = ['places', 'maps', 'geocoding'];

// Create the provider component
export function GoogleMapsProvider({ children }) {
    const { isLoaded, loadError } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: GOOGLE_MAPS_LIBRARIES
      });

  return (
    <GoogleMapsContext.Provider value={{ googleMapsIsLoaded: isLoaded, googleMapsLoadError: loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}